import React, { useCallback, useContext, useEffect, useState } from 'react';
import { format, isAfter, isBefore } from 'date-fns';

import { Tooltip } from '@bynder/design-system';
import { IconTime } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

import { API } from './api';
import { useDateFnsLocaleContext } from '../../connectors/Localization/DateFnsLocaleProvider';
import { InfoContext } from '../../context';
import { dispatchCustomEvent } from '../../helpers/useCustomEvent';

function Indicator(): React.ReactElement {
	const [endDate, setEndDate] = useState<string>();
	const { locale } = useDateFnsLocaleContext();
	const { lastChange } = useContext(InfoContext);

	const { translate } = useTranslate();

	const convertDate = useCallback(
		(date: string) => format(new Date(date), 'P', { locale }),
		[locale],
	);

	function openModal() {
		dispatchCustomEvent('openOutOfOfficeModal');
	}

	const checkCurrentOoo = useCallback(async () => {
		try {
			const response = await API.check();
			const { to_date, from_date } = response[0] || {};

			if (
				to_date &&
				isAfter(new Date(), new Date(from_date)) &&
				isBefore(new Date(), new Date(to_date))
			) {
				setEndDate(convertDate(to_date));

				return;
			}

			setEndDate(undefined);
		} catch (err) {
			console.error(err);
		}
	}, [convertDate]);

	useEffect(() => {
		checkCurrentOoo();
	}, [lastChange, checkCurrentOoo]);

	return endDate ? (
		// Wrapped in <a> so legacy custom theming can override colours
		// eslint-disable-next-line jsx-a11y/anchor-is-valid
		<a href="#" onClick={openModal} data-testid="ooo-indicator">
			{/* Wrapped in <i> so legacy custom theming can override colours and dimensions*/}
			<i className="fa tooltipped">
				<Tooltip
					content={translate('user-outofoffice.IsOutOfOfficeUntil', { '1': endDate })}
				>
					<IconTime />
				</Tooltip>
			</i>
		</a>
	) : (
		// eslint-disable-next-line react/jsx-no-useless-fragment
		<></>
	);
}

export default Indicator;
